if (!customElements.get("td-custom-reviews")) {
  class TdCustomReviews extends HTMLElement {
    constructor() {
      super();
      this.formLink = this.querySelector('.td-custom-reviews__form-link');
    }

    connectedCallback() {
      if (this.formLink) {
        this.formLink.addEventListener('click', this.handleFormClick.bind(this));
      }
    }

    handleFormClick(event) {
      event.preventDefault();
      const formId = this.formLink.dataset.formId;
      
      if (formId && window.omnisend) {
        window.omnisend = window.omnisend || [];
        window.omnisend.push(['openForm', formId]);
      }
    }
  }

  customElements.define("td-custom-reviews", TdCustomReviews);
}
